module.exports = __webpack_public_path__ + "img/parking.2a3d607a.svg";